import { OnboardingStepConfig, SuggestedName } from './types';

export const ONBOARDING_ROUTES = {
  // Hidden from flow 2026-07-04 (product call) — re-entry point when profiles return.
  whoFor: '/onboarding/who-for',
  careAbout: '/onboarding/care-about',
  cost: '/onboarding/cost',
  // Stories arm (registered by the screens' own tasks).
  stories: '/onboarding/stories',
  howWeHelp: '/onboarding/how-we-help',
  threeSteps: '/onboarding/three-steps',
  privacy: '/onboarding/privacy',
  socialProof: '/onboarding/social-proof',
  addItem: '/onboarding/add-item',
  scanning: '/onboarding/scanning',
  sampleScan: '/onboarding/sample-scan',
  doqReady: '/onboarding/doq-ready',
  // The doc-detail review screen (Task 9) — the flow's single save point.
  docDetail: '/onboarding/doc-detail',
  nameItem: '/onboarding/name-item',
  category: '/onboarding/category',
  reminder: '/onboarding/reminder',
  // Dev-only workbench (see Routes/routes.tsx's NODE_ENV guard) — never registered in production builds.
  sampleGallery: '/onboarding/sample-gallery',
} as const;

// Steps array is reference metadata (step/route/title/stepNumber) for the
// onboarding flow. The legacy features/sharing/review screens were retired in
// Task 12 — doc-detail (Task 9) is now the flow's single save point, followed
// by doq-ready. The design has no progress bar (removed 2026-07-04); this
// array intentionally keeps stepNumber for reference even though nothing
// currently renders it.
export const ONBOARDING_STEPS: OnboardingStepConfig[] = [
  // Mk3 profile-capture intro screens — precede the existing add-item flow.
  // They intentionally don't renumber the stepNumbers below (the pre-existing
  // add-item → doc-detail flow).
  {
    step: 'who-for',
    route: ONBOARDING_ROUTES.whoFor,
    title: 'Who are you organising for?',
    stepNumber: 0,
  },
  {
    step: 'care-about',
    route: ONBOARDING_ROUTES.careAbout,
    title: 'What life admin keeps you up at night?',
    stepNumber: 0,
  },
  {
    step: 'cost-proof',
    route: ONBOARDING_ROUTES.cost,
    title: 'Your admin is probably costing more than you think',
    stepNumber: 0,
  },
  {
    step: 'how-we-help',
    route: ONBOARDING_ROUTES.howWeHelp,
    title: 'Based on your answers, Doqit can help you…',
    stepNumber: 0,
  },
  {
    step: 'three-steps',
    route: ONBOARDING_ROUTES.threeSteps,
    title: "Three steps. That's it",
    stepNumber: 0,
  },
  {
    step: 'privacy',
    route: ONBOARDING_ROUTES.privacy,
    title: 'Your information stays yours',
    stepNumber: 0,
  },
  {
    step: 'social-proof',
    route: ONBOARDING_ROUTES.socialProof,
    title: 'Less stress. More control',
    stepNumber: 0,
  },
  {
    step: 'add-item',
    route: ONBOARDING_ROUTES.addItem,
    title: 'Now the magic bit.',
    stepNumber: 1,
  },
  {
    step: 'scanning',
    route: ONBOARDING_ROUTES.scanning,
    title: 'Creating your DOQ',
    stepNumber: 1,
  },
  {
    step: 'name-item',
    route: ONBOARDING_ROUTES.nameItem,
    title: 'Check item name',
    stepNumber: 2,
  },
  {
    step: 'category',
    route: ONBOARDING_ROUTES.category,
    title: 'Select a category',
    stepNumber: 3,
  },
  {
    step: 'reminder',
    route: ONBOARDING_ROUTES.reminder,
    title: 'Set a reminder',
    stepNumber: 4,
  },
  {
    step: 'doc-detail',
    route: ONBOARDING_ROUTES.docDetail,
    title: 'Here is your 1st DOQ!',
    stepNumber: 5,
  },
  {
    step: 'doq-ready',
    route: ONBOARDING_ROUTES.doqReady,
    title: 'Your first DOQ is ready!',
    stepNumber: 0,
  },
];

export const SUGGESTED_NAMES: SuggestedName[] = [
  { id: 'national-insurance', name: 'National Insurance' },
  { id: 'nhs-number', name: 'NHS Number' },
  { id: 'energy-bill', name: 'Energy Bill' },
  { id: 'netflix', name: 'Netflix' },
  { id: 'amazon', name: 'Amazon' },
  { id: 'passport', name: 'Passport' },
  { id: 'pet-insurance', name: 'Pet Insurance' },
  { id: 'wedding-anniversary', name: 'Wedding Anniversary' },
];

export const DEFAULT_DOCUMENT_NAME = 'My First DOQ';
